import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CampaignType } from '@corefront/redux-aba';
import { FRONT_API_GATEWAY_ERROR_CODES } from '@corefront/eva-fe-sdk';
import {
  Modal,
  Image,
  Button,
  Icon,
  NavigationBar,
  Typography,
} from '@modulor/react';
import Local from '../Local/Local';
import {
  useRedirectToCashier,
  useRedirectViaCampaignType,
} from '../../hooks/useDeeplinkRedirect';
import { playerLockTypeSelector } from '../../redux/reducers/app/playerLock';
import { resetTypePlayerLock } from '../../redux/actions/app/playerLock';
import { NAMESPACES } from '../../constants/namespaces';
import styles from './PlayerLockModal.module.css';
import {
  PLAYER_LOCK_MODAL,
  PLAYER_LOCK_MODAL_ACCEPT_BUTTON,
  PLAYER_LOCK_MODAL_CLOSE_BUTTON,
} from '../../constants/dataTestIds';
import { brandSelector } from '../../redux/reducers/app/params';

export const ERROR_CODES_WITH_SUPPORT_REDIRECT = [
  FRONT_API_GATEWAY_ERROR_CODES.LOCKED_BY_PRODUCT,
];

export const ERROR_CODES_WITH_ACCOUNT_REDIRECT = [
  FRONT_API_GATEWAY_ERROR_CODES.KYC_NOT_VERIFIED,
];

export const ERROR_CODES_WITH_CASHIER_REDIRECT = [
  FRONT_API_GATEWAY_ERROR_CODES.INSUFFICIENT_BALANCE,
];

const getIcon = (errorCode) => {
  switch (errorCode) {
    case FRONT_API_GATEWAY_ERROR_CODES.KYC_NOT_VERIFIED:
      return require('../../assets/images/error_kyc.png'); // eslint-disable-line
    case FRONT_API_GATEWAY_ERROR_CODES.INSUFFICIENT_BALANCE:
      return require('../../assets/images/error_no_money.png'); // eslint-disable-line

    default:
      return require('../../assets/images/error_default.png');
  }
};

const PlayerLockModal = () => {
  const dispatch = useDispatch();
  const type = useSelector(playerLockTypeSelector);
  const brand = useSelector(brandSelector);

  const redirectViaCampaignType = useRedirectViaCampaignType();
  const redirectCashier = useRedirectToCashier();

  const titleKey = `${type}.title`;
  const descriptionKey = `${type}.description`;

  const redirectVerification = () => {
    redirectViaCampaignType({ to: CampaignType.AccountVerification });
  };

  const redirectSupport = () => {
    redirectViaCampaignType({ to: CampaignType.Support });
  };

  const closeModal = () => {
    dispatch(resetTypePlayerLock());
  };

  return (
    <Modal
      openModal={!!type}
      toggleModal={closeModal}
      shadowClick
      minDesktopModalHeight={100}
      buttonNumber={0}
      dataTestId={PLAYER_LOCK_MODAL}
      header={
        <NavigationBar
          transparent
          right={
            <Icon
              name="close"
              onClick={closeModal}
              dataTestId={PLAYER_LOCK_MODAL_CLOSE_BUTTON}
            />
          }
        />
      }
    >
      <div className={styles.content}>
        <Image src={getIcon(type)} className={styles.image} />
        <Typography variant="large-title-semibold" className={styles.title}>
          <Local namespace={NAMESPACES.ERROR}>{titleKey}</Local>
        </Typography>
        <Typography variant="body-regular" className={styles.description}>
          <Local namespace={NAMESPACES.ERROR}>{descriptionKey}</Local>
        </Typography>
        {ERROR_CODES_WITH_SUPPORT_REDIRECT.includes(type) ? (
          <Button
            onClick={redirectSupport}
            variant="primary"
            dataTestId={PLAYER_LOCK_MODAL_ACCEPT_BUTTON}
          >
            <Local namespace={NAMESPACES.ERROR}>Support</Local>
          </Button>
        ) : ERROR_CODES_WITH_CASHIER_REDIRECT.includes(type) ? (
          <Button
            onClick={redirectCashier}
            variant="deposit"
            dataTestId={PLAYER_LOCK_MODAL_ACCEPT_BUTTON}
          >
            <Local namespace={NAMESPACES.ERROR}>To_deposit</Local>
          </Button>
        ) : ERROR_CODES_WITH_ACCOUNT_REDIRECT.includes(type) ? (
          <>
            {/* TODO: very temporary solution. remove it! */}
            {brand === 'BETON' ? (
              <Button
                onClick={closeModal}
                variant="primary"
                dataTestId={PLAYER_LOCK_MODAL_ACCEPT_BUTTON}
              >
                <Local>Ok</Local>
              </Button>
            ) : (
              <Button
                onClick={redirectVerification}
                variant="primary"
                dataTestId={PLAYER_LOCK_MODAL_ACCEPT_BUTTON}
              >
                <Local namespace={NAMESPACES.ERROR}>Verify</Local>
              </Button>
            )}
          </>
        ) : (
          <Button
            onClick={closeModal}
            variant="primary"
            dataTestId={PLAYER_LOCK_MODAL_ACCEPT_BUTTON}
          >
            <Local>Ok</Local>
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default PlayerLockModal;
